<!--
 * @Description:商机
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-04 17:35:14
 * @LastEditors: cxh
-->
<template>
  <cos-table
    :columns="columns"
    @fetch="fetch"
    @mask="showMask"
    :tableId="tableIdByPath('business')"
    ref="tableRef"
    rowKey="id"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'saleChanceName'">
        <router-link :to="'/fbu/business/view?id=' + record.id" :title="record.saleChanceNameByTxt">
          <BusinessName
            appId="cos_fbu"
            v-if="record.saleChanceName"
            v-model:value="record.saleChanceName"
            v-model:label="record.saleChanceNameByTxt"
          />
          <p v-else>--</p>
        </router-link>
      </template>
      <template v-if="column.dataIndex === 'action'">
        <MoreButton>
          <SellerButton
            :workCode="record.dutyBy"
            type="link"
            @click="handleEdit(record)"
            v-permission="permissionPage?.edit"
            >编辑</SellerButton
          >
          <a-button type="link" @click="handleDelete(record)" v-permission="permissionPage?.del">删除</a-button>
        </MoreButton>
      </template>
    </template>
  </cos-table>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/gucangSales/chanceManage'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  arkCodeId: {
    type: String
  }
})
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    businessList({
      arkCodeId: props.arkCodeId,
      saleChanceRefId: route.query.cosId as string,
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  } else {
    setTimeout(() => {
      callBack([])
    }, 500)
  }
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/fbu/business/edit',
    query: {
      id: row.id,
      returnPath: route.fullPath
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const columns = ref([
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 200 },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '预计月销售额(万)', dataIndex: 'planSaleAmount', width: 150 },
  { title: '商机创建时间', dataIndex: 'createTime', width: 190 },
  { title: '商机阶段', dataIndex: 'status', dicData: dataConfig.businessStatusEnum },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])
</script>
<script lang="ts">
export default { name: 'tabsBusiness' }
</script>
